import styled from 'styled-components';

import { WEBSITE_ANALYTICS } from '../../../../theme/tokens';

export const Disc = styled.span`
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: ${WEBSITE_ANALYTICS.glyphBg};
  color: ${WEBSITE_ANALYTICS.glyph};

  svg {
    display: block;
  }
`;
